import styled from 'styled-components';
import { StyledRadioProps } from './Radio.types';

export const StyledRadio = styled.div<StyledRadioProps>`
  position: relative;
  display: flex;
  align-items: center;
  opacity: ${(props: StyledRadioProps) => (props.isDisabled ? 0.27 : 1)};

  .radio__input {
    position: relative;
    display: block;
    margin: 0;
    height: var(--radio-button-input-size, 16px);
    width: var(--radio-button-input-size, 16px);
    border: var(--radio-button-input-border-size, 4px) solid;
    border-color: ${(props: StyledRadioProps) =>
      props.isChecked
        ? 'var(--radio-button-input-border-active-color, green)'
        : 'var(--radio-button-input-border-color, #000)'};
    background-color: var(--radio-button-input-bg-color, #fff);
    border-radius: 50%;
    appearance: none;
    cursor: ${(props: StyledRadioProps) =>
      props.isDisabled ? 'default' : 'pointer'};
    transition: all 0.3s;

    &:focus-visible {
      outline: dashed 2px var(--radio-button-main-color, #000);
      outline-offset: 1px;
    }
  }
  .radio__label {
    position: relative;
    cursor: ${(props: StyledRadioProps) =>
      props.isDisabled ? 'default' : 'pointer'};
  }

  ${(props) => props.customStyle}
`;
